import { State } from './types';

export const selectViews = (state: State) => state.savedViewsIndex.views;
export const selectMetaData = (state: State) => state.savedViewsIndex.metadata;
